import { useCallback, useEffect, useState } from 'react';
import {
  listPoolShippings,
  type ApiClient,
  type IframePoolShipping,
} from '../../modules/api';

export interface PoolShippingsData {
  shippings: IframePoolShipping[];
  totalCount: number;
  activeOutCount: number;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Loads the user's pool_shippings feed for the Deliveries tab. Currently
 * backed by a stubbed mock inside `listPoolShippings`; the hook is shaped
 * so the real network swap is a one-line change in the endpoint module.
 */
export function usePoolShippings(client: ApiClient): PoolShippingsData {
  const [shippings, setShippings] = useState<IframePoolShipping[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [activeOutCount, setActiveOutCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const page = await listPoolShippings(client, { page: 1, per: 20 });
      setShippings(page.shippings);
      setTotalCount(page.meta.totalCount);
      setActiveOutCount(page.meta.activeOutCount);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, [client]);

  useEffect(() => {
    void load();
  }, [load]);

  return { shippings, totalCount, activeOutCount, loading, error, refetch: load };
}
